import React, { useContext, useEffect, useState } from 'react'
import { Modal, Empty } from 'antd'
import UpdateTicketModal from './UpdateTicketModal'
import { GET_TICKET_BY_STATUS_INPUT } from '../../../graphql/query'
import { useQuery } from '@apollo/client'
import LoadingSpinner from '../../LoadingSpinner'
import UserContext from '../../../context/UserContext'
import SupportTicketCount from './SupportTicketCount'
import { v4 as uuidv4 } from 'uuid'
// import {BsFillEyeFill} from "react-icons/bs"

// interface MenuItem {
//   label: string
//   key: string
//   title: string
// }

// const items: MenuItem[] = [
//   {
//     label: 'OPEN',
//     title: 'Open',
//     key: '1'
//   },

//   {
//     label: 'INPROGRESS',
//     title: 'In-progress',
//     key: '2'
//   },

//   {
//     label: 'RESOLVED',
//     title: 'Resolved',
//     key: '3'
//   }
// ]

interface IProps {
  getCategoryLabel: any
  priorityLabel: any
}

const SupportEngineerTicketData: React.FC<IProps> = ({ getCategoryLabel, priorityLabel }) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [ticketsData, setTicketsData] = useState([])
  const [selectedTicketNumber, setSelectedTicketNumber] = useState(null)
  const [selectedStatus, setSelectedStatus] = useState<any>(null)
  const [searchQuery, setSearchQuery] = useState<any>('')
  const [priority, setPriority] = useState<any>(null)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const showEnteries = 10
  const { currentUser } = useContext(UserContext)

  const { data, loading } = useQuery(GET_TICKET_BY_STATUS_INPUT, {
    variables: {
      input: {
        Status: selectedStatus,
        query: searchQuery,
        Priority: priority,
        supportEngineerId: parseInt(currentUser.id),
        limit: showEnteries,
        offset: (currentPage - 1) * showEnteries
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Support-Tickets'
      }
    }
  })

  useEffect(() => {
    if (data?.getTicketbyStatus) {
      setTicketsData(data?.getTicketbyStatus?.tickets)
    }
  }, [data])

  const handleModalOpen = (record: any) => {
    setSelectedTicketNumber(record)
    setIsModalVisible(true)
  }

  const handleModalClose = () => {
    setIsModalVisible(false)
  }

  const getStatusLabel = (statusId: number) => {
    switch (statusId) {
      case 1:
        return 'Open'
      case 3:
        return 'In-Progress'
      case 2:
        return 'Resolved'
      default:
        return ''
    }
  }

  const headMap = [
    'S.No',
    'Ticket Number',
    'BG Account Id',
    'Subject',
    'Description',
    'Resolution',
    'Status',
    'Priority',
    'Category',
    'Action'
  ]

  const handleDropdownChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value === 'null' ? null : event.target.value
    setSelectedStatus(value)
  }

  const handleSearchInputChange = (value: any) => {
    let searchValue = value
    if (searchValue.length > 0) {
      setSearchQuery(searchValue)
    } else {
      setSearchQuery('')
    }
  }

  const handlePriority = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value === 'null' ? null : event.target.value
    setPriority(value)
  }

  // Pagination
  const totaltickets: any = data?.getTicketbyStatus?.ticketcount
  const totalPages = Math.ceil(totaltickets / showEnteries)

  // const indexOfLastticket = currentPage * showEnteries
  const indexOfFirstticket = currentPage * showEnteries - showEnteries
  // const currentticket = ticketsData.slice(indexOfFirstticket, indexOfLastticket)

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const nextPage = () => {
    if (totalPages > 0) {
      setCurrentPage((prevPage: number) => prevPage + 1)
    }
  }

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage: number) => prevPage - 1)
    }
  }

  // Generate snake handle pagination numbers
  const generatePaginationNumbers = () => {
    const numbers = []
    const maxVisibleNumbers = 4 // Maximum visible pagination numbers

    if (totalPages <= maxVisibleNumbers) {
      // If total pages are less than or equal to max visible numbers, show all
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i)
      }
    } else {
      const middleIndex = Math.ceil(maxVisibleNumbers / 2) // Middle index of the pagination numbers
      let startPage = currentPage - middleIndex + 1
      let endPage = currentPage + middleIndex - 1

      if (startPage < 1) {
        // If start page is less than 1, adjust start and end page accordingly
        endPage = startPage + maxVisibleNumbers - 1
        startPage = 1
      } else if (endPage > totalPages) {
        // If end page is greater than total pages, adjust start and end page accordingly
        startPage = endPage - maxVisibleNumbers + 1
        endPage = totalPages
      }

      for (let i = startPage; i <= endPage; i++) {
        numbers.push(i)
      }
    }

    return numbers
  }

  return (
    <div className='card mb-5 mb-xl-8'>
      <div className='d-flex justify-content-between'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Tickets</span>
            <span className='text-primary mt-1 fw-semibold fs-7'>
              {ticketsData.length} Tickets recorded
            </span>
          </h3>
        </div>
      </div>
      <div className='px-4 py-2'>
        <SupportTicketCount />
      </div>
      <div className='d-flex ms-10'>
        <input
          placeholder='Search Ticket no., Title, Description'
          style={{
            padding: '10px',
            border: '1px solid rgb(215, 209, 209)',
            width: '35%',
            minWidth: '100px',
            borderRadius: '10px'
          }}
          value={searchQuery}
          onChange={(e) => handleSearchInputChange(e.target.value)}
        />
        <div className='d-flex align-items-center justify-content-end flex-grow-1 gap-3 me-10'>
          <span>
            <select
              className='form-control text-primary bg-light-primary'
              name='priority'
              id='priority'
              style={{
                width: '140px',
                height: '42px',
                borderRadius: '5px',
                border: '#f1faff'
              }}
              value={priority}
              onChange={handlePriority}
            >
              <option value='null' selected>
                Select Priority
              </option>
              <option value='LOW'>Low</option>
              <option value='MEDIUM'>Medium</option>
              <option value='HIGH'>High</option>
            </select>
          </span>
          <span className='w-30 me-4'>
            <select
              className='form-control text-primary bg-light-primary'
              name='priority'
              id='priority'
              style={{
                width: '140px',
                height: '42px',
                borderRadius: '5px',
                border: '#f1faff'
              }}
              value={selectedStatus}
              onChange={handleDropdownChange}
            >
              <option value='null' selected>
                Select Status
              </option>
              <option value='OPEN'>Open</option>
              <option value='RESOLVED'>Resolved</option>
              <option value='INPROGRESS'>In-progress</option>
            </select>
          </span>
        </div>
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className='card-body py-3'>
          {!!ticketsData ? (
            <div className='table-responsive border border-muted rounded-2'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bolder fs-6 text-primary bg-light-primary'>
                    {headMap?.map((el: string, index: number) => (
                      <th className='ps-4 min-w-100px' key={uuidv4()} scope='col'>
                        {el}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {ticketsData?.map((curEl: any, index: any) => (
                    <React.Fragment key={uuidv4()}>
                      <tr>
                        <td className='ps-4 cursor-pointer fw-bold'>
                          {indexOfFirstticket + index + 1}
                        </td>
                        <td className='ps-4 cursor-pointer fw-bold'>{curEl?.ticketNumber}</td>

                        <td className='ps-4 cursor-pointer fw-bold'>{curEl?.bgAccountId}</td>
                        <td className='ps-4 cursor-pointer fw-bold'>{curEl?.title}</td>
                        <td
                          className='ps-4 cursor-pointer fw-bold'
                          data-toggle='tooltip'
                          title={curEl?.description}
                        >
                          {curEl?.description && curEl.description.length > 250
                            ? `${curEl.description.slice(0, 250)}...`
                            : curEl?.description}
                        </td>

                        <td>{curEl?.resolution}</td>
                        <td className='ps-4 cursor-pointer fw-bold'>
                          {getStatusLabel(curEl?.StatusId)}
                        </td>

                        <td
                          className={`ps-4 cursor-pointer fw-bold ${
                            priorityLabel(curEl?.PriorityId).className
                          }`}
                        >
                          {priorityLabel(curEl?.PriorityId).label}
                        </td>
                        <td className='ps-4 cursor-pointer fw-bold'>
                          {getCategoryLabel(curEl?.TypeId)}
                        </td>
                        <td
                          className='ps-4 cursor-pointer text-primary fw-bold'
                          onClick={() => handleModalOpen(curEl)}
                        >
                          <i className='bi bi-pencil-fill me-1'></i> Update Ticket
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <Empty />
          )}
          {/* Pagination */}
          {ticketsData?.length > 0 && (
            <div className='row'>
              <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
              <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                <div
                  className='dataTables_paginate paging_simple_numbers'
                  id='kt_table_users_paginate'
                >
                  <ul className='pagination pb-3'>
                    <li
                      className={`paginate_button page-item ${currentPage === 1 ? 'disabled' : ''}`}
                    >
                      <button
                        type='button'
                        aria-controls='kt_table_users'
                        data-dt-idx='0'
                        className='btn primary page-link'
                        onClick={prevPage}
                      >
                        <i className='previous'></i>
                      </button>
                    </li>
                    {generatePaginationNumbers().map((pageNumber) => (
                      <li
                        key={pageNumber}
                        className={`paginate_button page-item ${
                          currentPage === pageNumber ? 'active' : ''
                        }`}
                      >
                        <button
                          type='button'
                          aria-controls='kt_table_users'
                          data-dt-idx={pageNumber}
                          className='btn primary page-link'
                          onClick={() => paginate(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      </li>
                    ))}
                    <li
                      className={`paginate_button page-item ${
                        currentPage === totalPages ? 'disabled' : ''
                      }`}
                    >
                      <button
                        type='button'
                        aria-controls='kt_table_users'
                        data-dt-idx='0'
                        className='btn primary page-link'
                        onClick={nextPage}
                      >
                        <i className='next'></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <Modal
        destroyOnClose
        title='Update Ticket'
        open={isModalVisible}
        onOk={handleModalClose}
        onCancel={handleModalClose}
        footer={null}
      >
        <UpdateTicketModal
          closeModal={handleModalClose}
          updateTicketData={selectedTicketNumber}
          id={currentUser.id}
        />
      </Modal>
    </div>
  )
}

export default SupportEngineerTicketData
